// DOMParser statt innerHTML an einem Element des Live-Dokuments: dort laedt der Browser
// <img src=x onerror=...> sofort und fuehrt den Handler aus. Geparste Dokumente sind inert.
export const stripHTML = (value) =>
	new DOMParser().parseFromString(value ?? '', 'text/html').body.textContent ||
	''
